export enum InstallationQueryParamsEnum {
  search = 'search',
  type = 'type',
  page = 'page',
  status = 'status',
  sortBy = 'sortBy',
  pageSize = 'pageSize',
  customerType = 'customerType',
  sortDirection = 'sortDirection',
  includeDismantled = 'includeDismantled',
  productChargingStationType = 'productChargingStationType',
}
